<template>
  <div class="login">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-0">
            <v-card-text>
              <a :href="homepage" class="text-deco">
                <div class="pb-4">
                  <v-img width="200" :src="siteConfig.logo" class="mx-auto"></v-img>
                </div>
              </a>
              <div class="pb-3 text-center text-subtitle-1 font-weight-bold black--text">Silahkan konfirmasi password
                baru Anda</div>
              <div class="text-subtitle-2 py-5">
                <span class="black--text">Sudah punya akun?</span>
                <router-link :to="{ name: 'login' }">
                  <span class="font-weight-bold pl-2">Login di sini</span>
                </router-link>
              </div>
              <v-alert v-model="alerts.show" v-if="alerts.show" dense color="red lighten-1" class="white--text"
                dismissible>{{ alerts.message }}</v-alert>
              <v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
                <div>
                  <div class="text-subtitle-2 primary--text pb-1">Password</div>
                  <v-text-field @click:append="showPassword" :type="passwordType" :rules="passwordRules"
                    @focus="() => fieldErrors.password = ''" :error-messages="fieldErrors.password" v-model="password"
                    validate-on-blur single-line outlined class="color-primary rounded-lg password-field" height="40"
                    dense :append-icon="passwordIcon" hide-details="auto"></v-text-field>
                </div>
                <div>
                  <div class="text-subtitle-2 primary--text pb-1">Konfirmasi Password</div>
                  <v-text-field @click:append="showPassword" :type="passwordType" :rules="repasswordRules"
                    @focus="() => fieldErrors.repassword = ''" :error-messages="fieldErrors.repassword"
                    v-model="repassword" validate-on-blur single-line outlined
                    class="color-primary rounded-lg password-field" height="40" dense :append-icon="passwordIcon"
                    hide-details="auto"></v-text-field>
                </div>
                <div class="pt-5">
                  <v-btn v-if="isAttempting" x-large depressed color="primary" class="col-12 rounded-lg">
                    <div class="subtitle-2">Sedang Diproses ...</div>
                  </v-btn>
                  <!-- <v-btn
                    v-else
                    x-large
                    depressed
                    color="primary"
                    class="col-12 rounded-lg"
                    type="submit"
                  >-->
                  <v-btn v-else x-large depressed color="black" class="col-12 rounded-lg white--text" type="submit">
                    <div class="subtitle-2">Ubah Password</div>
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  components: {},
  data() {
    return {
      homepage: process.env.VUE_APP_HOMEPAGE,
      password: "",
      repassword: "",
      passwordType: "password",
      passwordIcon: "mdi-eye",
      passwordRules: [v => !!v || "Password tidak boleh kosong"],
      repasswordRules: [v => !!v || "Konfirmasi Password tidak boleh kosong"]
    };
  },
  computed: {
    ...mapState("kiriminaja", [
      "siteConfig",
    ]),
    ...mapState("auth", ["isAttempting", "alerts", "fieldErrors"])
  },
  methods: {
    ...mapActions("auth", ["confirmNewPassword", "verifyToken"]),
    ...mapMutations("auth", ["failed"]),

    showPassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.passwordIcon = "mdi-eye-off";
      } else {
        this.passwordType = "password";
        this.passwordIcon = "mdi-eye";
      }
    },
    onLogin() {
      if (this.password !== this.repassword) {
        this.failed({
          code: "error_response",
          type: "error",
          message: "Password tidak cocok"
        });
      } else {
        if (this.$refs.formLogin.validate()) {
          this.confirmNewPassword({
            token: this.$route.params.token,
            password: this.password,
            repassword: this.repassword
          }).then(() => {
            this.$router.push({
              name: "login"
            });
          });
        }
      }
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Ubah Password");
    this.verifyToken({ token: this.$route.params.token }).catch(() => {
      this.$router.push("/ubah-password");
    });
  }
};
</script>
